import RemovingIndicator from './RemovingIndicator';

export default RemovingIndicator;
